angular.module("avant.customer_applications.directives").directive "amountEmailMask", ->
  restrict: 'A'
  require: 'ngModel'
  link: (scope, element, attributes, ngModel) ->

    modelSet = (value) ->
      return unless value
      value

    viewSet = (value) ->
      return unless value
      array = value.split('@')
      userName = array[0]

      firstChar = userName.charAt(0)
      lastChar = userName.charAt(userName.length - 1)
      middleChars = userName.slice(1, -1).replace(/./g, '*')

      viewValue = firstChar + middleChars + lastChar + '@' + array[1]

    # The parser needs to be at the end of the $parsers array, and the formatter
    # needs to be at the beginning of the $formatters array; otherwise
    # validations can run on the masked values

    ngModel.$parsers.push(modelSet)
    ngModel.$formatters.unshift(viewSet)

    element.bind "blur", =>
      element.val(viewSet(ngModel.$modelValue))

    element.bind "focus", =>
      return unless ngModel.$modelValue
      element.val(ngModel.$modelValue).trigger('input')
